import React from 'react';
import './Nosotros.css';

const timelineData = [
  {
    year: '1988',
    title: 'Nacimiento de Humen',
    description: 'Inicio de operaciones como un pequeño negocio familiar dedicado a la venta de comestibles, sentando las bases de lo que hoy es una empresa con múltiples unidades de negocio.'
  },
  {
    year: '1990',
    title: 'Expansión del Negocio',
    description: 'Ampliación del catálogo de productos, incorporando diversos rubros más allá de los comestibles para satisfacer las necesidades crecientes de nuestros clientes.'
  },
  {
    year: '2000',
    title: 'Consolidación Familiar',
    description: 'El negocio se consolida como un referente en la zona, destacándose por su atención personalizada y variedad de productos, manteniendo siempre la esencia familiar.'
  },
  {
    year: '2015',
    title: 'Modernización',
    description: 'Implementación de nuevos sistemas y tecnologías para mejorar la experiencia de compra y la gestión del negocio.'
  },
  {
    year: '2024',
    title: 'Apertura de Humen Delicias',
    description: 'Inauguración de nuestra nueva sucursal especializada en productos delicatessen y alimentos gourmet, expandiendo nuestra presencia en el mercado.'
  },
  {
    year: '2025',
    title: 'Lanzamiento de Mini Market',
    description: 'Reformulación del negocio de comestibles hacia un formato moderno de Mini Market, adaptándonos a las nuevas tendencias del mercado y necesidades de nuestros clientes.'
  }
];

function Nosotros() {
  return (
    <div className="nosotros-container">
      <h1>Nuestra Historia</h1>
      <div className="timeline">
        {timelineData.map((item, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-year">
              <span>{item.year}</span>
            </div>
            <div className="timeline-content">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Nosotros; 